export default "__VITE_ASSET__2ccdf8f6__"